import React from 'react';
import PropTypes from 'prop-types';
import {
  EmptyState,
  Icon,
  Skeleton,
  StatusController,
  Typography,
} from '@knockrentals/knock-shared-web-v2';
import { makeCss } from '../../../../knock-design-system';

export const EMPTY_STATE_MESSAGE = 'No properties';
export const SKELETON_LABEL = 'loading property data';

const useCss = makeCss({
  messageText: {
    margin: '14px',
  },
});

const PropertyTabStatusController = ({
  children,
  errorMessage,
  isEmpty,
  isLoading,
}) => {
  const css = useCss();
  return (
    <StatusController
      empty={isEmpty}
      emptyFallback={
        <Typography align="center" css={css.messageText}>
          {EMPTY_STATE_MESSAGE}
        </Typography>
      }
      error={Boolean(errorMessage)}
      errorFallback={
        <EmptyState flex={1}>
          <Icon color="denim.600" name="component-alert-error" size={48} />
          <EmptyState.Title>{'Error fetching the property'}</EmptyState.Title>
          <EmptyState.Description>{errorMessage}</EmptyState.Description>
        </EmptyState>
      }
      loading={isLoading}
      loadingFallback={
        <Skeleton aria-label={SKELETON_LABEL} height={'100%'} variant="rect" />
      }
    >
      {children}
    </StatusController>
  );
};

PropertyTabStatusController.propTypes = {
  children: PropTypes.node,
  errorMessage: PropTypes.string,
  isEmpty: PropTypes.bool,
  isLoading: PropTypes.bool,
};

export default PropertyTabStatusController;
